import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/groups`,
});

// Attach token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* =========================
   GROUP ROUTES
========================= */

// Get all groups
export const getAllGroups = () => {
  return api.get("/");
};

// Get single group by ID
export const getGroupDetails = (id) => {
  return api.get(`/${id}`);
};

// Create group
export const createGroup = (data) => {
  return api.post("/create", data);
};

// Update group
export const updateGroup = (data) => {
  return api.put("/update", data);
};

// Delete group
export const deleteGroup = (groupId) => {
  return api.delete(`/${groupId}`);
};

// Add tests to group
export const addTestsToGroup = (data) => {
  return api.post("/add-tests", data);
};

// Remove test from group
export const removeTestFromGroup = (data) => {
  return api.post("/remove-test", data);
};
// Get child groups
export const getChildGroups = (parentId) => {
  return api.get(`/children/${parentId}`);
};